const urls = {
    chats: {
        get: { method: 'get', url: 'chats' },
        create: { method: 'post', url: 'chats' },
        getById: { method: 'get', url: 'chats/{id}' },
        update: { method: 'put', url: 'chats/{id}' },
        delete: { method: 'delete', url: 'chats/{id}' },
        addMembers: { method: 'post', url: 'chats/{id}/members' },
        getMembers: { method: 'get', url: 'chats/{id}/members' },
        removeMembers: { method: 'post', url: 'chats/{id}/members/remove' },
        updateMemberRole: { method: 'post', url: 'chats/{id}/members/role' },
        getMedia: { method: 'get', url: 'chats/{id}/media' },
        addTeamsToChat: { method: 'post', url: '/chats/{id}/teams' },
        removeTeamsFromChat: { method: 'post', url: '/chats/{id}/teams/remove' },
        getChatLogs: { method: 'get', url: 'chats/{id}/logs' },
        readMessage: { method: 'post', url: 'chats/{id}/read' },
        chatNotification: { method: 'put', url: 'chats/{id}/notifications' }
    },

    messages: {
        send: { method: 'post', url: 'chats/{id}/messages' },
        list: { method: 'get', url: 'chats/{id}/messages' },
        update: { method: 'put', url: 'chats/{id}/messages/{messageId}' },
        delete: { method: 'delete', url: 'chats/{id}/messages/{messageId}' },

    },
    wallet: {
        get: { method: 'get', url: 'wallets' },
        create: { method: 'post', url: 'wallets' },
        getMyWallet: { method: 'get', url: 'wallets/me' },
        getProviderBalance: { method: 'get', url: 'wallets/providers/balance' },
        withdarwFromWallet: { method: 'post', url: 'wallets/withdraw' },
        transferFromWallet: { method: 'post', url: 'wallets/transfer/w2w' },
        transferFromWalletToBank: { method: 'post', url: 'wallets/transfer/w2b' },
        addMoneyToWallet: { method: 'post', url: 'wallets/deposit' },
        withdrawFromWalletOtp: { method: 'post', url: 'wallets/withdraw/otp' },
        detailsById: { method: 'get', url: 'wallets/users/{userId}' }
    },
    transactions: {
        getListTransaction: { method: 'get', url: '/wallets/transactions' },
        checkTransactionStatus: { method: 'post', url: 'wallets/transactions/{id}/status' },
        getFilterListTransaction: { method: 'get', url: 'wallets/transactions/filter-list' },
    },
    task: {
        update: { method: 'put', url: 'tickets/{ticketId}/tasks/{taskId}/respond' },
    },
    courier: {
        list: { method: 'get', url: '/admin/courier-vendors' }
    },
    workStatus: {
        userAvailability: { method: 'put', url: 'users/{id}/availability' }
    },
    milestones: {
        addDocketDetails: { method: 'post', url: 'tickets/{ticketId}/milestones/{milestoneId}/tracking' }
    },
    approval_templates: {
        get: { method: 'get', url: 'admin/approval-templates' }
    },
    user: {
        getAttanedance: { method: 'get', url: 'users/{id}/attendance' },
        updateTicketAvailability: { method: 'put', url: 'users/{id}/ticket-availability' },
        postImageUrl: { method: 'post', url: 'medias/post-url' },
    }
}

export default urls;
